export default "__VITE_ASSET__fLW1jZjj__"